<template>
<div class="chapter">
<div class="inner_page">
<a id="page_vii"></a>
<h2 class="fm-title">List of Illustrations</h2>
<p class="illu1">1. Grenadier of a Volunteer regiment, c.1805</p>
<p class="illu1">2. ‘A Military Squabble about Dress’</p>
<p class="illu1">3. St George’s Volunteers charging down Bond Street</p>
<p class="illu1">4. <em class="italic">‘</em>Push on, brave York volunteers’</p>
<p class="illu1">5. The Battle of Châteauguay, 1813</p>
<p class="illu1">6. Lieutenant Colonel Charles de Salaberry leads his volunteers and militiamen at Châteauguay</p>
<p class="illu1">7. Lieutenant Colonel de Salaberry, victor of Châteauguay</p>
<p class="illu1">8. The Victorian amateur soldier, Staffordshire Rifle Volunteers, c.1860</p>
<p class="illu1">9. Officers of the 1st Aberdeenshire Rifles, 1881</p>
<p class="illu">10. Uniforms of the 1st Sutherland Volunteer Rifle Corps, 1860–1908</p>
<p class="illu">11. Bicycle-mounted Volunteers in South Africa, 1899</p>
<p class="illu">12. Officers of the 1st US Volunteer Cavalry, ‘Rough Riders’, at Long Island before embarkation for the invasion of Cuba, 1898</p>
<p class="illu">13. 1st US Volunteer Cavalry at Las Gausimas</p>
<p class="illu">14. Captain Parker’s Gatling guns on Cuba</p>
<p class="illu">15. 71st New York Volunteers in quarantine in the USA after the Cuban campaign</p>
<p class="illu">16. The Spanish Falangist leader, José Antonio Primo de Rivera, inspects his blue-shirted militia before the outbreak of the Spanish Civil War</p>
<p class="illu">17. Republican militia besieging the Alcázar</p>
<p class="illu">18. Heroic portrayal of Falangist militia in July 1936</p>
<p class="illu">19. Weapons inspection for Castroist MNR militiamen</p>
<p class="illu">20. MNR militia in action, probably during the Bay of Pigs invasion</p>
<p class="illu">21. Castroist troops advance behind T34/85 tanks during the Bay of Pigs fighting</p>
<p class="illu">22. MNR militia in action</p>
<p class="illu">23. MNR militiamen with Czech-made Soviet anti-aircraft artillery</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 05_Illustrations.vue?a98552ac